import { Component, Inject, OnInit} from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { OCRType } from '../Enum/common.enum';

@Component({
  selector: 'app-selectFieldTemplate',
  templateUrl: './selectFieldTemplate.component.html',
  styleUrls: ['./selectFieldTemplate.component.scss'] 
})

export class SelectFieldTemplateComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;   
  spinner:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any;
 
 filteredTempCategoryList:any=[]=[];
 currentIndex: number = 0;
 selectedTemplate:any=[]=[]; 
 searchTemplateName:string="";
 ShowNoRecordFoundTemplates:boolean=false;
 ImportTemplatesList:any=[]=[];
 TemplateIDImportTask: number = 0;
 selectedcategoryIDForImportTemp:number=0;
 showImportTemplate:boolean=false;
 typeForAddCategory:number=1;
 tempalteName:string="";
 categoryType:number=0;

  constructor(public dialogRef: MatDialogRef<SelectFieldTemplateComponent>,  
   private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,private statusConst: StatusConstant,
    private settingsService: SettingService) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
  }  
  
  ngOnInit(): void {  
    this.categoryType=0; 
    this.getActiveTemplateCategoriesAfterAdd();
    this.selectedcategoryIDForImportTemp=0;
    this.TemplateIDImportTask=0;
    this.currentIndex=0;
    this.getOCRTemplate();
    this.showImportTemplate=true;   
   }            
  
  
   getActiveTemplateCategoriesAfterAdd() {
    var ReqModel = {
      type: this.categoryType > 0 ? this.categoryType : 0,
      isCategoriesOnly: true,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)      
    }
    this.settingsService.getOCRTemplateCategories(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;       
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.filteredTempCategoryList = response.data;        
        }
        else {
          this.filteredTempCategoryList = [];        
        }
      }
      else {
        this.filteredTempCategoryList = [];       
      }
    });
   }

   getOCRTemplate() {
    var ReqModel = {
      cType: this.typeForAddCategory,
      templateType: this.categoryType > 0 ? this.categoryType : 0,
      categoryID:this.selectedcategoryIDForImportTemp,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.settingsService.getOCRTemplates(ReqModel).subscribe(response => {
      if(response != undefined) {
        this.responseHolder = response;       
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.ImportTemplatesList = response.data;  
          if(this.ImportTemplatesList.length>0){
            this.ShowNoRecordFoundTemplates=false;
          }else{
            this.ShowNoRecordFoundTemplates=true;
          }
        }else {
          this.ImportTemplatesList = [];
          this.ShowNoRecordFoundTemplates=true;     
        }
      }else {
        this.ImportTemplatesList = [];
        this.ShowNoRecordFoundTemplates=true;   
      }
    });
   }
  
   getTaskListThroughCategoryForImport(e: any, i: any) {
    this.TemplateIDImportTask=0;
    this.selectedTemplate=[];
    this.currentIndex = i;
    this.selectedcategoryIDForImportTemp=e;
    this.getOCRTemplate();
   }

   officeIdForImportFieldTemp:number=0;
   organizationIdForImportFieldTemp:number=0;

   SelectTemplate(data){
    this.officeIdForImportFieldTemp= data.organizationID;
    this.organizationIdForImportFieldTemp= data.organizationID;
    this.TemplateIDImportTask = data.templateID;
    this.tempalteName=data.tempalteName;
   }

   closeImportTaskTemplate() {
    this.showImportTemplate=false;
    this.dialogRef.close();
   }

   importTemplates(){
    var obj={
      tempalteName:this.tempalteName,
      templateID:this.TemplateIDImportTask
    }
    this.dialogRef.close(obj);
   }

   OnSelectCategoryImportFieldTemp($event) {

    this.selectedTemplate = [];
    this.selectedcategoryIDForImportTemp = 0;
    this.TemplateIDImportTask = 0;
    this.currentIndex = 0;
    this.showImportTemplate = true;
    //this.selectedTaskCategoryID = 0;
    const textLabel = $event.value;
    const categoryValue = textLabel == 'My Template' ? 0 : textLabel == 'Organization' ? 2 : 1;
    this.categoryType = categoryValue;
    this.getActiveTemplateCategoriesAfterAdd();
    this.getOCRTemplate();
  }
}
